import { Routes } from '@angular/router';
import { BaseLayout } from './core/layouts/base-layout/base-layout';
import { Home } from './features/home/home';
import { Courses } from './features/courses/courses';
import { SeoData } from './core/seo/interfaces/seo-data';
import { QuemSomosComponent } from './features/quem-somos/quem-somos.component';
import { Mentorship } from './features/mentorship/mentorship';
import { EntrarNaComunidadeComponent } from './features/entrar-na-comunidade/entrar-na-comunidade.component';
import { PoliticaDePrivacidadeComponent } from './features/politica-de-privacidade/politica-de-privacidade.component';
import { CourseLayout } from './core/layouts/course-layout/course-layout';

export const routes: Routes = [
  {
    path: '',
    component: BaseLayout,
    children: [
      {
        path: '',
        component: Home,
        data: {
          title: 'Code Dimension',
          description:
            'A Code Dimension e uma plataforma focada em ensinar Front-End e Angular, atraves de conteudos didaticos e relevantes!',
          url: 'https://www.codedimension.com.br/',
          image: 'https://codedimension.com.br/images/social-media-image.png',
        } as SeoData,
      },
      {
        path: 'cursos',
        component: Courses,
        data: {
          title: 'Cursos',
          description:
            'Confira nossos cursos e treinamentos para se tornar uma pessoa desenvolvedora de alto nível!',
          url: 'https://www.codedimension.com.br/cursos',
        } as SeoData,
      },
      {
        path: 'mentorias',
        component: Mentorship,
        data: {
          title: 'Mentorias',
          description:
            'Participe das mentorias mensais da Code Dimension: temas escolhidos pela comunidade, ao vivo com quem constrói software de verdade.',
          url: 'https://www.codedimension.com.br/mentorias',
        } as SeoData,
      },
      {
        path: 'quem-somos',
        component: QuemSomosComponent,
        data: {
          title: 'Sobre a Code Dimension',
          description:
            'Conheça a história da Code Dimension, nossa missão e valores.',
          url: 'https://www.codedimension.com.br/quem-somos',
        } as SeoData,
      },
      {
        path: 'entrar-na-comunidade',
        component: EntrarNaComunidadeComponent,
        data: {
          title: 'Entrar na comunidade',
          description:
            'Entre na comunidade Code Dimension e fique por dentro de todas as nossas novidades!',
          url: 'https://www.codedimension.com.br/entrar-na-comunidade',
        } as SeoData,
      },
      {
        path: 'politica-de-privacidade',
        component: PoliticaDePrivacidadeComponent,
        data: {
          title: 'Política de Privacidade | Code Dimension',
          description:
            'Conheça nossa Política de Privacidade e saiba como a Code Dimension protege seus dados e respeita suas escolhas de cookies em conformidade com a LGPD.',
          url: 'https://www.codedimension.com.br/politica-de-privacidade',
        } as SeoData,
      },
    ],
  },
  {
    path: 'cursos/testes-automatizados',
    component: CourseLayout,
    loadChildren: () =>
      import('./features/curso-testes-automatizados-com-angular/routes'),
  },
  {
    path: 'cursos/angular-moderno',
    component: CourseLayout,
    loadChildren: () => import('./features/curso-angular-moderno/routes'),
  },
  {
    path: 'cursos/introducao-ao-angular',
    component: CourseLayout,
    loadChildren: () => import('./features/curso-introducao-ao-angular/routes'),
  },
  {
    path: 'assinaturas/code-universe',
    component: CourseLayout,
    loadChildren: () => import('./features/code-universe/routes'),
  },
  {
    path: 'cursos/formularios-com-angular',
    component: CourseLayout,
    loadChildren: () =>
      import('./features/curso-formularios-com-angular/routes'),
  },
  {
    path: 'cursos/dominando-signal-forms',
    component: CourseLayout,
    loadChildren: () => import('./features/curso-signal-forms/routes'),
  },
  {
    path: 'cursos/spec-driven-development',
    component: CourseLayout,
    loadChildren: () =>
      import('./features/curso-spec-driven-development/routes'),
  },
  {
    path: 'cursos/desenvolvimento-com-ia',
    redirectTo: '/cursos/dominando-agentes-de-ia',
    // component: CourseLayout,
    // loadChildren: () =>
    //   import('./features/curso-desenvolvimento-com-ia/routes'),
  },
  {
    path: 'cursos/dominando-agentes-de-ia',
    component: CourseLayout,
    loadChildren: () =>
      import('./features/curso-dominando-agentes-de-ia/routes'),
  },
  {
    path: 'eventos/black-friday',
    component: CourseLayout,
    loadChildren: () => import('./features/evento-black-friday/routes'),
  },
  // evita que links errados percam o tráfego
  {
    path: 'cursos/signal-forms',
    redirectTo: '/cursos/dominando-signal-forms',
  },
  // a rota antiga de captura continua válida e redireciona para a comunidade
  {
    path: 'se-inscreva',
    redirectTo: 'entrar-na-comunidade',
    pathMatch: 'full',
  },
  // rede de segurança para rotas desconhecidas: evita o erro NG04002
  // (Recognizer.noMatchError) e devolve o visitante para a home
  {
    path: '**',
    redirectTo: '',
  },
];
